import React from 'react'
import OutwaredBinReportTable from '../../../Comman/OutwaredBinReportTable'

const Wash_InwardedBin = ({ userData }) => {
    return (
        <>
            <OutwaredBinReportTable  location={"washing"}/>
        </>
    )
}

export default Wash_InwardedBin